import FlujoCajaV2 from "../../components/FlujoCajaV2";

const FlujoCajaV2Page = () => <FlujoCajaV2 />;

export default FlujoCajaV2Page;
